import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slider.css';

function SliderPage() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
    };

    return (
        <div className="slider-container">
            <Slider {...settings} className="hero-slider">
                <div>
                    <img src="/assets/slides/img1.jpg" alt="Jewelry Slide 1" className="slider-image" />
                </div>
                <div>
                    <img src="/assets/slides/img2.jpg" alt="Jewelry Slide 2" className="slider-image" />
                </div>
                <div>
                    <img src="/assets/slides/img3.jpg" alt="Jewelry Slide 3" className="slider-image" />
                </div>
            </Slider>
        </div>
    );
}

export default SliderPage;
